import React, {TextareaHTMLAttributes} from 'react'
import {FieldValues, FieldErrors} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'
import {KTSVG} from '../KTSVG'
import {KTText} from '../KTText'

interface Props
 extends TextareaHTMLAttributes<HTMLTextAreaElement> {
 label?: string
 id?: string
 name: string
 className?: string
 wrapperClassName?: string
 inputWrapperClassName?: string
 labelClassName?: string
 errorIconClassName?: string
 iconPath?: string
 showIcon?: boolean
 helperTextClass?: string
 helperText?: string
 register?: FieldValues
 errors?: FieldErrors | undefined
}

const TextareaField = ({
 label,
 className,
 showIcon = false,
 wrapperClassName,
 iconPath,
 labelClassName,
 errorIconClassName,
 name,
 required,
 id,
 disabled = false,
 readOnly = false,
 register,
 placeholder,
 helperTextClass,
 inputWrapperClassName,
 helperText,
 errors,
 rows,
 cols,
}: Props) => {
 return (
  <div className={`${wrapperClassName}`}>
   <div
    className={`${inputWrapperClassName} ${
     disabled && '!bg-[#F5F8FA]'
    } form-field-wrapper py-2 px-4 relative !disabled:text-[#33393D] text-[#33393D] rounded-lg border border-solid border-[#E6EBF0] bg-white focus-within:border-[#000000]`}
   >
    {label && (
     <label
      htmlFor={id}
      className={`input-label ${labelClassName} relative pb-1 text-[#4E83E4] text-xs font-medium`}
     >
      {label}
      {required && (
       <span className='required-field pl-[2px]'>*</span>
      )}
     </label>
    )}
    <textarea
     rows={rows}
     cols={cols}
     id={id ?? name}
     placeholder={placeholder}
     disabled={disabled}
     readOnly={readOnly}
     className={`form-input ${className} !disabled:bg-blue-300 relative text-[#80868C] pr-6 text-lg font-normal block w-full ${
      errors?.[name] && 'border-[#CC293F]'
     }`}
     {...register}
    />
    {(errors?.[name] ?? showIcon) && (
     <KTSVG
      path={`${iconPath ?? '/media/icons/icon_error.svg'}`}
      svgClassName={`${errorIconClassName} absolute bottom-[10px] z-11 right-[10px]`}
     />
    )}
   </div>
   {helperText && !errors?.[name] && (
    <KTText className={helperTextClass}>
     {helperText}
    </KTText>
   )}
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </div>
 )
}

export {TextareaField}
